import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Dumbbell, Mail, Lock, ArrowRight } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handle = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(form.email, form.password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-[#f8fafd] dark:bg-[#121212] relative overflow-hidden">
      <div className="absolute -top-32 -left-32 w-96 h-96 rounded-full bg-blue-200/30 dark:bg-blue-900/10 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 -right-32 w-96 h-96 rounded-full bg-green-200/30 dark:bg-green-900/10 blur-3xl pointer-events-none" />

      <div className="relative w-full max-w-sm">
        <div className="flex flex-col items-center mb-6">
          <div
            className="w-14 h-14 rounded-2xl flex items-center justify-center mb-3"
            style={{ background: 'linear-gradient(135deg, #1a73e8 0%, #4285f4 60%, #8ab4f8 100%)', boxShadow: '0 8px 24px rgba(26,115,232,0.35)' }}
          >
            <Dumbbell className="w-7 h-7 text-white" />
          </div>
          <h1 className="text-xl font-bold text-[#202124] dark:text-[#e8eaed]">GymPortal</h1>
          <p className="text-xs text-[#5f6368] dark:text-[#9aa0a6] mt-0.5">Owner Console — sign in to manage your gym</p>
        </div>

        <div className="google-card p-6 bg-white dark:bg-[#303134] border border-[#dadce0] dark:border-[#3c4043]">
          {error && (
            <div className="mb-4 p-3 rounded-xl bg-red-50 dark:bg-red-950/40 border border-red-200 dark:border-red-900 text-xs text-red-700 dark:text-red-300 font-medium">
              {error}
            </div>
          )}

          <form onSubmit={handle} className="space-y-4">
            <div>
              <label className="text-xs font-semibold text-[#5f6368] dark:text-[#9aa0a6] block mb-1.5">Email</label>
              <div className="google-input-box px-3.5 py-2.5 flex items-center gap-2">
                <Mail className="w-4 h-4 text-[#9aa0a6] shrink-0" />
                <input
                  type="email"
                  required
                  placeholder="owner@yourgym.com"
                  value={form.email}
                  onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
                  className="w-full bg-transparent text-sm font-medium outline-none text-[#202124] dark:text-[#e8eaed]"
                />
              </div>
            </div>

            <div>
              <label className="text-xs font-semibold text-[#5f6368] dark:text-[#9aa0a6] block mb-1.5">Password</label>
              <div className="google-input-box px-3.5 py-2.5 flex items-center gap-2">
                <Lock className="w-4 h-4 text-[#9aa0a6] shrink-0" />
                <input
                  type="password"
                  required
                  placeholder="••••••••"
                  value={form.password}
                  onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
                  className="w-full bg-transparent text-sm font-medium outline-none text-[#202124] dark:text-[#e8eaed]"
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full py-2.5 rounded-full text-sm font-semibold bg-[#1a73e8] hover:bg-[#1557b0] text-white shadow-xs transition-all cursor-pointer flex items-center justify-center gap-1.5 disabled:opacity-60"
            >
              {loading ? 'Signing in...' : 'Sign In'}
              {!loading && <ArrowRight className="w-4 h-4" />}
            </button>
          </form>
        </div>

        <p className="text-center text-[11px] text-[#9aa0a6] mt-5">
          Don't have a gym listed yet?{' '}
          <Link to="/register" className="font-semibold text-[#1a73e8] dark:text-[#8ab4f8]">
            Register
          </Link>
        </p>
      </div>
    </div>
  );
}
